import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import graphql from 'services/querys';
import { NewUserType } from 'types/new-user';

const useSearchParty = (searchText: string) => {
  const [searchEnabled, setSearchEnabled] = useState(false);
  const [parties, setParties] = useState<NewUserType[]>([]);

  const searchPartyResponse = useQuery(
    ['searchParty', searchText], // 1. Key reactiva: si searchText cambia, la query se refresca
    () => graphql.searchParty(searchText), // 2. Función con el argumento explícito
    {
      // 3. Opciones de control
      enabled: searchEnabled && !!searchText && searchText.length >= 3,
      refetchOnWindowFocus: false,
      // Mejora la UX: no borra los resultados anteriores mientras carga los nuevos
      keepPreviousData: true,
    }
  );

  useEffect(() => {
    // eslint-disable-next-line no-undef
    let timeoutId: NodeJS.Timeout | undefined;

    if (searchText && searchText.length >= 3) {
      timeoutId = setTimeout(() => setSearchEnabled(true), 300);
    }

    return () => {
      setSearchEnabled(false);

      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [searchText]);

  useEffect(() => {
    if (!searchText || (searchText && searchText.length < 3)) {
      setParties([]);
    }

    if (searchPartyResponse.isSuccess && searchPartyResponse.data) {
      setParties(searchPartyResponse.data.searchParty as unknown as NewUserType[]);
    }

    if (searchPartyResponse.isError) {
      setParties([]);
    }
  }, [searchPartyResponse.isSuccess, searchPartyResponse.data, searchPartyResponse.isError, searchText]);

  return {
    parties,
    loading: searchPartyResponse.isLoading,
    // Additive fields for consumers that render explicit search states.
    isDebouncing: !!searchText && searchText.length >= 3 && !searchEnabled,
    isFetching: searchPartyResponse.isFetching,
    isError: searchPartyResponse.isError,
  };
};

export default useSearchParty;
